import React, { useEffect, useState } from 'react';
import { HiOutlineMenuAlt4 } from "react-icons/hi";
import { FaRegTrashAlt } from "react-icons/fa";

export const FeaturesBenefits = ({data, setData}) => {
  const [items, setItems] = useState([
    { id: 1, text: "50+ Screens beautifully crafted mobile design views", isEditable: false },
    { id: 2, text: "Organized components sheets with components, typography, colors,", isEditable: false },
    { id: 3, text: "100% Vector & Easy to Use", isEditable: false },
  ]);

  useEffect(() => {
    setData(prev => ({
      ...prev,
      featuresBenefits: items
    }));
  }, [items, setData]);

  const handleAdd = () => {
    setItems([...items, { id: Date.now(), text: "", isEditable: true }]);
  };

  const handleDelete = (id) => {
    setItems(items.filter(item => item.id !== id));
  };

  const handleChange = (id, text) => {
    setItems(items.map(item => item.id === id ? { ...item, text } : item));
  };

  const handleBlur = (id) => {
    setItems(items.map(item => item.id === id ? { ...item, isEditable: false } : item));
  };

  const handleEdit = (id) => {
    setItems(items.map(item => item.id === id ? { ...item, isEditable: true } : item));
  };

  return (
    <div className="bg-[#f0f0f0] dark:bg-[#282828] p-4 rounded-lg my-4">
      <div className="flex items-center space-x-2">
        <div className="bg-[#F08383] w-4 h-4 rounded-lg" />
        <h1>Features & Benefits</h1>
      </div>

      {items.map(item => (
        <div key={item.id} className='flex items-center space-x-3'>
          <div className='flex items-center space-x-2 bg-white dark:bg-transparent border dark:border-[#5B5B5B] p-2 rounded my-2 w-full'>
            <HiOutlineMenuAlt4 />
            {item.isEditable ? (
              <input
                type="text"
                value={item.text}
                onChange={(e) => handleChange(item.id, e.target.value)}
                onBlur={() => handleBlur(item.id)}
                autoFocus
                className="w-full bg-transparent border-none focus:outline-none"
              />
            ) : (
              <p onClick={() => handleEdit(item.id)}>{item.text}</p>
            )}
          </div>
          <FaRegTrashAlt 
            onClick={() => handleDelete(item.id)} 
            className='text-red-500 bg-white dark:bg-transparent border dark:border-[#5B5B5B] p-2 rounded text-3xl cursor-pointer' 
          />
        </div>
      ))}
      <button onClick={handleAdd} className='bg-black text-white dark:bg-white dark:text-black w-full py-2 my-2 rounded'>+ Add</button>
    </div>
  );
};
